import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { useAppContext } from '@contexts/app';
import { TenantRolesDropdownProps, TenantRolesDropdownRespSuccess } from './types';
import { useQueryParams } from '@hooks/queryParams';
import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';
import { snakeToCamelCase } from '@utils/textHelpers';

export const useTenantRolesDropdown = ({ primaryRole }: TenantRolesDropdownProps) => {
  const { panel } = usePanel();
  const { tenantId } = useParams();
  const {
    isDropdownEnabled: enabled,
    admin: { isLogged },
  } = useAppContext();
  const { parseParams } = useQueryParams();

  const queryParams = parseParams({
    primaryRole,
    tenantId: panel ? tenantId : undefined,
  });

  const { data, error, isPending } = useQuery<TenantRolesDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.tenantRoles, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/tenant_roles${queryParams}`, panel }),
    select: (d) => {
      return {
        ...d,
        records: d.records.map(({ name, ...rest }) => ({ ...rest, name: snakeToCamelCase(name) })),
      };
    },
    placeholderData: (previousData) => previousData as TenantRolesDropdownRespSuccess,
    enabled: Boolean(panel ? tenantId && isLogged : enabled),
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && Boolean(panel ? tenantId && isLogged : enabled),
  };
};
